<template>
	<div v-if="visible" class="map-areas">
		<leaflet-geo-json
			v-for="area of areas"
			:key="area.id"
			:data="area.area"
			v-bind="$attrs"
			:visible="visible"
			:polygonOptions="polygonOptions"
		/>
	</div>
</template>

<script>
export default {
	name: 'MapAreas',
	props: {
		areas: {
			type: Array,
			required: true
		},
		visible: {
			type: Boolean,
			required: true
		},
		polygonOptions: Object
	}
};
</script>
